import script from "./AtividadesCardHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadesCardHome.vue?vue&type=script&setup=true&lang=js"

import "./AtividadesCardHome.vue?vue&type=style&index=0&id=a53df42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a53df42e"]])

export default __exports__